import axios from ".";


export const verifyPincode = async (pincode) => {
    const result = await axios.get(`/auth/verify?code=${pincode}`)
    return result.data;
}